import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'sidebarMinimized';

@Injectable({
	providedIn: 'root',
})
export class SidebarService {
	// Il menu laterale ricorda l'ultimo stato scelto dall'utente (aperto/nascosto)
	// attraverso il refresh; al primo accesso parte chiuso (minimizzato).
	private minimizedSubject = new BehaviorSubject<boolean>(SidebarService.readStored());
	minimized$ = this.minimizedSubject.asObservable();

	private static readStored(): boolean {
		try {
			const stored = localStorage.getItem(STORAGE_KEY);
			return stored === null ? true : stored === 'true';
		} catch {
			return true;
		}
	}

	toggleMinimized() {
		const minimized = !this.minimizedSubject.value;
		this.minimizedSubject.next(minimized);
		try {
			localStorage.setItem(STORAGE_KEY, minimized.toString());
		} catch {
			/* storage non disponibile: lo stato resta solo in memoria */
		}
	}
}
